import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoMetaService } from './services/seo-meta-service';
import { CUSTOM_COMPONENTS_LIST } from './components';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CUSTOM_DIRECTIVE_LIST } from './directive';
import { NativeEventsService } from './services/native-events/native-events.service';

@NgModule({
  declarations: [
    CUSTOM_COMPONENTS_LIST,
    CUSTOM_DIRECTIVE_LIST,
  ],
  exports: [
    CUSTOM_COMPONENTS_LIST,
    CUSTOM_DIRECTIVE_LIST
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbTypeaheadModule
  ],
  providers: [SeoMetaService, NativeEventsService]
})

export class AACoreModule { }
